import i18next  from 'i18next';

import es from './es';
import pt from './pt';
import en from './en';

i18next.addResourceBundle('es', 'dialog', es);
i18next.addResourceBundle('en', 'dialog', en);
i18next.addResourceBundle('pt', 'dialog', pt);